import createReactComponent from '../createReactComponent';
export default createReactComponent('math-equal-lower', 'IconMathEqualLower', [
  ['path', { d: 'M19 18l-14 -4', key: 'svg-0' }],
  ['path', { d: 'M19 14l-14 -4l14 -4', key: 'svg-1' }],
]);
